import { markAttributesForHref } from 'common/Prose/utils/link'
import { ChangeLinkArgs, CreateEditLinkCallbackFn } from './Types'

export const editLink =
  ({ view, linkPosition }: ChangeLinkArgs): CreateEditLinkCallbackFn =>
  ({ link, text }) => {
    const tr = view.state.tr

    if (link) {
      text = text === '' ? link : text
      const newTo = linkPosition.from + text.length

      tr.insertText(text, linkPosition.from, linkPosition.to)
      tr.addMark(linkPosition.from, newTo, view.state.schema.marks.link.create(markAttributesForHref(link)))
      tr.scrollIntoView()
    } else {
      tr.removeMark(linkPosition.from, linkPosition.to, view.state.schema.marks.link)
      tr.scrollIntoView()
    }

    view.dispatch(tr)
    view.focus()
  }
